// ProceduresCard.jsx

import React, { useEffect } from "react";
import { FaStethoscope } from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import moment from "moment";

import { GetSurgicaldata } from "../../../StateManagement/Reducers/PatientState";

const ProceduresCard = ({ onExportData }) => {
  const dispatch = useDispatch();
  const params = useParams();

  const Surgicaldata = useSelector((state) => state.Revision.Surgicaldata);

  const dtFormat = localStorage.getItem("dateFormat");

  useEffect(() => {
    dispatch(GetSurgicaldata({ pid: params.pid }));
  }, []);

  useEffect(() => {
    if (Surgicaldata && onExportData) {
      onExportData(
        Surgicaldata.map((item) => ({
          procedureName: item.procedure_name || "-",
          codeType: item.code_type || "-",
          // procedureDate: item.procedure_date || "-",
          procedureDate: item.procedure_date
            ? moment(item.procedure_date).format("MMM DD, YYYY")
            : "-",
          status: item.status || "-",
        })),
      );
    }
  }, [Surgicaldata, onExportData]);

  const getStatusClass = (status) => {
    switch (status) {
      case "Completed":
        return "active-status";

      case "In Progress":
        return "warning-status";

      case "Cancelled":
        return "inactive-status";

      default:
        return "";
    }
  };

  return (
    <div className="care-summary-card">
      <div className="care-summary-title-wrap">
        <FaStethoscope
          style={{ fontWeight: "400" }}
          className="care-summary-main-icon"
        />
        <h3 className="care-summary-title">Procedures & Surgeries</h3>
      </div>

      <div className="care-summary-body">
        {Surgicaldata && Surgicaldata.length > 0 ? (
          Surgicaldata.slice(-3)
            .reverse()
            .map((item, index, arr) => (
              <div
                key={index}
                className={`care-summary-row ${
                  index !== arr.length - 1 ? "care-summary-border" : ""
                }`}
              >
                <div className="care-summary-content">
                  <div className="care-summary-heading">
                    {item.procedure_name}
                  </div>

                  <div className="care-summary-subtext dark-sub">
                    Code Type: {item.code_type}
                  </div>

                  <div className="care-summary-subtext">
                    Procedure Date:{" "}
                    {item.procedure_date
                      ? moment(item.procedure_date).format("MMM DD, YYYY")
                      : "-"}
                  </div>
                </div>

                <div
                  className={`care-summary-status-wrap ${getStatusClass(
                    item.status,
                  )}`}
                >
                  <span className="care-summary-status-dot"></span>

                  <span className="care-summary-status-text">
                    {item.status}
                  </span>
                </div>
              </div>
            ))
        ) : (
          <div className="care-summary-empty">No Procedures Added</div>
        )}
      </div>
    </div>
  );
};

export default React.memo(ProceduresCard);
